import React, { useState, useEffect } from 'react';

const CinemaSlideshow = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  
  const images = [
    {
      src: '/cinema2.jpg',
      alt: 'Private Cinema at 36 Đ. Số 2, An Phú, Thủ Đức, Thành phố Hồ Chí Minh - View 1',
      caption: 'Private cinema with 40 chairs and LED screen'
    },
    {
      src: '/cinema.jpg',
      alt: 'Private Cinema at 36 Đ. Số 2, An Phú, Thủ Đức, Thành phố Hồ Chí Minh - View 2',
      caption: 'Private cinema with 40 chairs and LED screen'
    }
  ];

  // Auto-advance slideshow every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [images.length]);

  const goToSlide = (index) => {
    setCurrentImageIndex(index);
  };

  const goToPrevious = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
  };

  const goToNext = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  return (
    <div className="cinema-slideshow">
      <div className="cinema-image-container">
        <img 
          src={images[currentImageIndex].src} 
          alt={images[currentImageIndex].alt} 
          className="cinema-image" 
        />
        <div className="cinema-caption">
          <p>{images[currentImageIndex].caption}</p>
        </div>
        
        {/* Navigation arrows */}
        <button 
          className="slideshow-nav slideshow-prev" 
          onClick={goToPrevious}
          aria-label="Previous image"
        >
          ‹
        </button>
        <button 
          className="slideshow-nav slideshow-next" 
          onClick={goToNext}
          aria-label="Next image"
        >
          ›
        </button>
        
        {/* Dots indicator */}
        <div className="slideshow-dots">
          {images.map((_, index) => (
            <button
              key={index}
              className={`slideshow-dot ${index === currentImageIndex ? 'active' : ''}`}
              onClick={() => goToSlide(index)}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default CinemaSlideshow; 